import React, { Component } from "react";
import { withRouter } from "../common/with-router";
import http from "../http-common";
import ReportService from "../services/report.service"

class ReportsBranches extends Component {
  constructor(props) {
    super(props);
    this.handleError = this.handleError.bind(this);
    var token = window.sessionStorage.getItem("token");
    this.state = {
      baseURL: http.defaults.baseURL + "/reports",
      token: token,
      branches: null
    };
    ReportService.listBranches()
    .then(resp => {
      const branches = resp.data.branches;
      this.setState({branches: branches});
    })
    .catch(this.handleError);
  }

  handleError(e) {
    if (e.response?.status === 403) {
      this.props.router.navigate("/login");
    }
  }

  render() {
    return (
      <div>
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Branch</th>
              <th></th>
              <th>Managers</th>
              <th className="text-center">Tutors</th>
              <th className="text-center">Students</th>
            </tr>
          </thead>
          <tbody>
            {this.state.branches === null && (
              <tr>
                <td>Loading...</td>
              </tr>
            )}
            {this.state.branches !== null && this.state.branches.map((branch, index) => (
              <tr key={index}>
                <td>
                  {branch.name}
                </td>
                <td>
                  {branch.active === 1 && (<span className="small badge rounded-pill text-bg-primary">Active</span>)}
                  {branch.active === 0 && (<span className="small badge rounded-pill text-bg-secondary mr-1">Inactive</span>)}
                  &nbsp;
                  {branch.online === 1 && (<span className="small badge rounded-pill text-bg-secondary">Online</span>)}
                  {branch.online === 0 && (<span className="small badge rounded-pill text-bg-primary">In-person</span>)}
                </td>
                <td>
                  {branch.managers.map((manager, index) => (
                    <div key={index}>{manager.firstName} {manager.lastName} ({manager.email})</div>
                  ))}
                </td>
                <td className="text-center">{branch.members?.tutors || 0}</td>
                <td className="text-center">{branch.members?.students || 0}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

}

export default withRouter(ReportsBranches);